import React from 'react';
import styled from 'styled-components';
import { TraceData } from '../service/trace-service';
import RRWebPlayer from './rrweb-player';
import { Details } from './trace-view-types';

const RRWeb = styled.div`
	width: 100%;
	background-color: var(--video-bg-color);
	border-radius: var(--radius);
	outline: none;
	> .rr-player {
		background-color: var(--video-bg-color);
	}
`;
const VideoContainer = styled.div`
	width: 100%;
	video {
		background-color: var(--video-bg-color);
		border-radius: var(--radius);
		outline: none;
	}
`;

export default (props: { trace: TraceData | null, details: Details }) => {
	const { trace, details } = props;

	let player;
	if (trace) {
		if (details.loaded) {
			if(details.events!=null){
			if (details.events?.length !== 0) {
				player = <RRWeb>
					<RRWebPlayer autoPlay={true} events={details.events}/>
				</RRWeb>;
			} else {
				player = <div>服务器端可回溯文件未找到，无法播放</div>;
			}
			}else{
                player = <div>服务器端可回溯文件未找到，无法播放</div>;
			}

		} else {
			player = <div className="tips">视频加载中...</div>;
		}
	} else {
		player = <div className="tips">视频加载中...</div>;
	}

	return <VideoContainer>
		{player}
	</VideoContainer>;
}
